import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Register from "./components/authentication/Register";
import Login from "./components/authentication/login";
import Homepage from "./components/Homepage";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import HomepageProvider from "./components/context/HomepageState";
import DashboardProvider from "./components/VendorPanel/context/DashboardState";
import CategoryProvider from "./components/Admin/context/CategoryState";
import ProductDetail from "./components/ProductDetail";
import Cart from "./components/Cart";
import Transaction from "./components/VendorPanel/Transaction/Transaction";
import ReferralDialog from "./components/authentication/RefferalDialog";
import DashboardContent from "./components/VendorPanel/Dashboard/DashboardContent";
import Shoping from "./components/VendorPanel/Shop/Shoping";
import ShopingProvider from "./components/VendorPanel/context/ShopingState";
import AboutUsPage from "./components/AboutUsPage";
import  ContactPage  from "./components/ContactPage";
import TeamMemberPage from "./components/TeamMemberPage";
import Earning from "./components/VendorPanel/Earning/Earning";
import MainPage from "./components/MainPage";
import AdminContent from "./components/Admin/AdminContent";
import ProductApproval from "./components/Admin/ProductApproval";
import LoginPage from "./components/Admin/LoginPage";
import Earnings from "./components/Admin/Earnings";
import Genealogy from "./components/Admin/Geneology";
import UserRegistration from "./components/Admin/UserRegistration";
import ProductCategory from "./components/Admin/Productcategory/ProductCategory";

// Authentication Wrappers
const RequireAuth = ({ children }) => {
  const isAuthenticated = sessionStorage.getItem("user"); // Using sessionStorage
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

const RedirectIfAuth = ({ children }) => {
  const isAuthenticated = sessionStorage.getItem("user"); // Using sessionStorage
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : children;
};


// Authentication Wrappers admin
const RequireAuthAdmin = ({ children }) => {
  const isAuthenticated = sessionStorage.getItem("admin_user"); // Using sessionStorage
  return isAuthenticated ? children : <Navigate to="/admin-login" replace />;
};

const RedirectIfAuthAdmin = ({ children }) => {
  const isAuthenticated = sessionStorage.getItem("admin_user"); // Using sessionStorage
  return isAuthenticated ? <Navigate to="/admin-dashboard" replace /> : children;
};

function App() {
  const theme = createTheme({
    typography: {
      fontFamily: 'Quicksand, "Open Sans", sans-serif',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <HomepageProvider>
          <Routes>
            {/* Move ALL routes inside this single Routes component */}
            <Route path="/" element={<MainPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/our-team" element={<TeamMemberPage />} />
            <Route path="/shop" element={<Homepage />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/refferal" element={<ReferralDialog />} />
            <Route path="/registers" element={<Register />} />
            
            <Route path="/admin-login" element={
              <RedirectIfAuthAdmin>
              <LoginPage />
              </RedirectIfAuthAdmin>
              } />
           
            <Route path="/admin-dashboard" element={
               <RequireAuthAdmin>
              <AdminContent />
              </RequireAuthAdmin>
              } />
            <Route path="/product-approval" element={
              <RequireAuthAdmin>
              <ProductApproval />
              </RequireAuthAdmin>
              } />
            <Route path="/admin-earnings" element={
              <RequireAuthAdmin>
              <Earnings />
              </RequireAuthAdmin>
              } />
            <Route path="/admin-geneology" element={
              <RequireAuthAdmin>
              <Genealogy />
              </RequireAuthAdmin>
              } />
            <Route path="/user-registration" element={
              <RequireAuthAdmin>
              <UserRegistration />
              </RequireAuthAdmin>
              } />
              <Route path="/product-category" element={
              <RequireAuthAdmin>
                <CategoryProvider>
              <ProductCategory />
              </CategoryProvider>
              </RequireAuthAdmin>
              } />
           

           {/* Vendor section */}
            <Route 
              path="/login" 
              element={
                <RedirectIfAuth>
                  <Login />
                </RedirectIfAuth>
              } 
            />

            {/* Protected routes */}
            <Route path="/dashboard" element={
              <RequireAuth>
                <DashboardProvider>
                <ShopingProvider>
                  <DashboardContent />
                  </ShopingProvider>
                </DashboardProvider>
              </RequireAuth>
            } />

<Route path="/vendor-shop" element={
              <RequireAuth>
                <ShopingProvider>
                  <Shoping />
                </ShopingProvider>
              </RequireAuth>
            } />

<Route path="/cart" element={
              <RequireAuth>
                <DashboardProvider>
                
                  <Cart />
                  
                </DashboardProvider>
              </RequireAuth>
            } />

<Route path="/earnings" element={
              <RequireAuth>
                <DashboardProvider>
                <ShopingProvider>
                  <Earning />
                  </ShopingProvider>
                </DashboardProvider>
              </RequireAuth>
            } />

<Route path="/transactions" element={
              <RequireAuth>
                <DashboardProvider>
                <ShopingProvider>
                
                  <Transaction />
                  </ShopingProvider>
                </DashboardProvider>
              </RequireAuth>
            } />

            

            {/* Repeat the DashboardProvider pattern for other protected routes */}
          </Routes>
        </HomepageProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
